<script setup lang="ts">
import { cn } from '@/lib/utils'

const props = defineProps<{
  modelValue?: string
  type?: string
  placeholder?: string
  label?: string
  error?: string
  disabled?: boolean
  required?: boolean
}>()

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()

const handleInput = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label
      v-if="props.label"
      class="text-sm font-medium text-[color:var(--color-ink)]"
    >
      {{ props.label }}
      <span v-if="props.required" class="text-error ml-0.5">*</span>
    </label>
    <input
      :type="props.type ?? 'text'"
      :value="props.modelValue"
      :placeholder="props.placeholder"
      :disabled="props.disabled"
      :required="props.required"
      @input="handleInput"
      :class="cn(
        'flex h-10 w-full px-3 py-2 text-sm transition-colors',
        'rounded-[var(--radius-md)]',
        'bg-[color:var(--color-surface)] text-[color:var(--color-ink)]',
        'placeholder:text-[color:var(--color-ink-soft)] placeholder:opacity-60',
        'focus:outline-none focus:ring-2 focus:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        props.error
          ? 'border border-error focus:ring-error/50'
          : 'border border-[color:var(--color-border-soft)] focus:border-[color:var(--color-border-strong)] focus:ring-primary/50'
      )"
    />
    <span v-if="props.error" class="text-xs text-error">{{ props.error }}</span>
  </div>
</template>
